import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, TextCallout1 } from 'blocket-ui'
import styled from 'styled-components'

export const createOptions = (items, required) => {
  const options = [...items]
  if (!required) {
    options.unshift({
      label: 'Alla',
      value: '',
      color: '#9a9999',
    })
  }

  return options
}

export const DropdownCollection = ({
  currentQuery,
  className,
  queryKey,
  onChange,
  items,
  required,
  label: filterLabel,
  defaultValue,
}) => {
  const selectedValue = currentQuery[queryKey] || defaultValue || ''
  const options = useMemo(() => createOptions(items, required), [items, required])

  const handleChange = useCallback(
    (e) => {
      const {
        target: { value },
      } = e
      onChange(e, queryKey, value)
    },
    [queryKey, onChange],
  )

  return (
    <div className={className}>
      <TextCallout1>{filterLabel}</TextCallout1>

      <Dropdown
        options={options}
        onChange={handleChange}
        style={{ marginTop: 8 }}
        size="tiny"
        value={selectedValue}
      />
    </div>
  )
}

// Make it a styled component so that we can
// so we can use it as a component selector
// https://www.styled-components.com/docs/advanced#caveat
export default styled(DropdownCollection)``

DropdownCollection.propTypes = {
  label: PropTypes.string.isRequired,
  currentQuery: PropTypes.object.isRequired,
  queryKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
}
